import { Button, Card } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { InstantPayStatusModal } from "./instantPayStatusModal";
import request from "superagent";
import { getAuthHeader } from "../../utils/superagent";
import { useSelector } from "react-redux";
import { EMPLOYEE_ROLES } from "@src/appV2/Employee/constants";
import { statusChangeReason } from "../../constants/instantpay";
import { isEmpty } from "lodash";
const InstantPayCard = styled(Card)`
  .ant-card-body {
    padding: 12px;
    p {
      margin: 0;
    }
  }
`;
const textStyle = {
  color: "#595959",
};

function InstantPayDrawerCard({ facilityInfo }) {
  const [isVisible, setVisible] = useState(false);
  const [cardTextVisible, setCardTextVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [displayValue, setDisplayValue] = useState("");
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const performedByEmail = useSelector((state: any) => state.session.adminProfile.email || "");
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const roles = useSelector((state: any) => state.session.adminProfile.roles || {});

  const fetchInstantPay = async () => {
    await request
      .get(`${global.api}/facilityprofile/hcf`)
      .query({
        userId: facilityInfo.facility.userId,
        instantPayUsersLimit: 1,
      })
      .set(await getAuthHeader())
      .then((response) => {
        if (response.status === 200) {
          if (!isEmpty(response.body.hcf)) {
            const result = response.body.hcf.isInstantPayEnabled;
            if (result) {
              setDisplayValue("ON");
            } else {
              setDisplayValue("OFF");
            }
          } else {
            setDisplayValue("OFF");
          }
        } else {
          setDisplayValue("OFF");
        }
      });
  };

  const enableInstantPay = async () => {
    await request
      .post(`${global.api}/facilityprofile/enable-hcf`)
      .send({
        userId: facilityInfo.facility.userId,
        performedBy: performedByEmail,
        reason: statusChangeReason.enable,
      })
      .set(await getAuthHeader())
      .then((response) => {
        if (response.status === 200) {
          setDisplayValue("ON");
          setLoading(false);
          setVisible(false);
        } else {
          setDisplayValue("OFF");
          setLoading(false);
          setVisible(false);
        }
      });
  };

  const prohibitInstantPay = async () => {
    await request
      .post(`${global.api}/facilityprofile/prohibit-hcf `)
      .send({
        userId: facilityInfo.facility.userId,
        performedBy: performedByEmail,
        reason: statusChangeReason.prohibit,
      })
      .set(await getAuthHeader())
      .then((response) => {
        if (response.status === 200) {
          setDisplayValue("OFF");
          setLoading(false);
          setVisible(false);
        } else {
          setDisplayValue("ON");
          setLoading(false);
          setVisible(false);
        }
      });
  };

  useEffect(() => {
    void fetchInstantPay();
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityInfo]);

  const onOk = async (value) => {
    setLoading(true);
    if (value === "ON") {
      void enableInstantPay();
      return;
    }
    if (value === "OFF") {
      void prohibitInstantPay();
    }
  };

  const onCancel = () => setVisible(false);

  const onTextVisible = () => setCardTextVisible(!cardTextVisible);

  const onEdit = () => {
    setVisible(true);
  };

  function Actions() {
    return (
      <Button type="link" onClick={onEdit}>
        Edit
      </Button>
    );
  }

  return (
    <>
      <InstantPayCard
        title={`InstantPay Status: ${displayValue} `}
        extra={
          (Array.isArray(roles) || roles.length) &&
          roles.includes(EMPLOYEE_ROLES.SHIFT_PRICING) && <Actions />
        }
      >
        {cardTextVisible && (
          <>
            {displayValue === "ON" && (
              <p style={textStyle}>
                {`${facilityInfo.facility.name} is an InstantPay Facility.
          This means that HCPs that use Stripe are not prohibited from
          InstantPay and clock in with the app will receive some of their shift
          earning right when the shift is complete.You can view an HCPs "InstantPay Rate"
          (how much will be paid when the shift is complete) in the HCP drawer.`}
              </p>
            )}

            {displayValue === "OFF" && (
              <p style={textStyle}>
                {`${facilityInfo.facility.name} is not an InstantPay Facility.
         This means that HCPs working at this workplace will be paid 100% of shift
         earnings once the shift is verified.`}
              </p>
            )}
          </>
        )}
        {
          <Button type="link" onClick={onTextVisible}>
            {cardTextVisible
              ? "Click to hide this text"
              : "Click to learn more about what this means"}
          </Button>
        }
      </InstantPayCard>
      {
        <InstantPayStatusModal
          visible={isVisible}
          onCancel={onCancel}
          value={displayValue}
          onSubmit={onOk}
          loading={loading}
        />
      }
    </>
  );
}

export { InstantPayDrawerCard };
